module.exports = __webpack_public_path__ + "static/gardener-f7dbeb91da807fd88b1565e48ddc6412.png";